import React from 'react';
import PropTypes from 'prop-types';

import BaseListItem from '../BaseListItem';

const SiteContentListItem = props => {
    const { id, title, url, photoURL, onClick = () => {} } = props;

    const imageBlock = (
        <>
            {photoURL && <img src={photoURL} alt={title} className="px-0 py-2 card-img-right" />}
            {!photoURL && (
                <img
                    src="/assets/images/generic-icon-article.svg"
                    alt=""
                    className="px-2 pt-2 card-img-right download bg-gray-lightest"
                />
            )}
        </>
    );

    return (
        <BaseListItem
            id={id}
            type="siteContent"
            title={title}
            url={url}
            showFavoriteIcon={false}
            imageBlock={imageBlock}
            contentBlock={
                <a onClick={() => onClick(url)} onKeyDown={() => onClick(url)} className="card-link" href={url}>
                    <h3
                        className="card-title mt-1 mb-0 ml-0 mx-0 py-0 display8 bold d7-truncate2 truncate-lines"
                        dangerouslySetInnerHTML={{ __html: title }}
                    />
                    <p className="display9 secondary mt-1 mb-0">Website Page</p>
                </a>
            }
        />
    );
};

SiteContentListItem.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    title: PropTypes.string.isRequired,
    url: PropTypes.string,
    photoURL: PropTypes.string,
    onClick: PropTypes.func,
};

export default SiteContentListItem;
